import React, {forwardRef, useState} from 'react';
import {Controller} from 'react-hook-form';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import {InputAdornment, TextField} from "@mui/material";

const getNestedError = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

export const InputMain = forwardRef(
    ({
         label,
         labelHeader,
         placeholder,
         rules,
         control,
         name,
         type = 'text',
         maxLength,
         minLength,
         startAdornment,
         endAdornment,
         className,
         onClickIconStart,
         onClickIconEnd,
         showPassword,
         disabled,
         showError = true,
         min,
         max,
         ...anotherProps
     }, ref) => {
        const [isFocused, setIsFocused] = useState(false);


        const inputProps = {};

        if (maxLength) inputProps.inputProps = maxLength;
        if (minLength) inputProps.minLength = minLength;
        if (min) inputProps.min = min;
        if (max) inputProps.max = max;

        const EndIcon = showPassword ? Visibility : VisibilityOff;

        const typePassword = showPassword ? 'text' : 'password';

        return (
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({field, formState: {errors}}) => {
                    const error = getNestedError(errors, name);

                    return (
                        <div
                            className={`main-input-wrapper  ${className ? className : ''}`}
                            ref={ref}
                        >
                            {labelHeader
                                &&
                                <p className={`input-main-label-header ${error?.message ? 'errorLabel' : ''}`}>
                                    {labelHeader}
                                    {rules?.required
                                        && <span className='input-main-label-header-required'>
                                        *
                                </span>
                                    }
                                </p>
                            }
                            <TextField
                                ref={ref}
                                {...anotherProps}
                                {...field}
                                disabled={disabled}
                                autoComplete='on'
                                error={!!error?.message}
                                type={showPassword ? typePassword : type}
                                value={field.value}
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                                placeholder={placeholder}
                                label={label}
                                inputProps={{...inputProps}}
                                InputLabelProps={{
                                    shrink: (type === 'date' || type === 'time') ? true : !!field?.value || isFocused,
                                }}

                                InputProps={{
                                    startAdornment: startAdornment &&
                                        <InputAdornment
                                            onClick={onClickIconStart}
                                            className={`${error?.message ? 'error-svg' : ''}`}
                                            position='start'
                                        >
                                            {startAdornment}
                                        </InputAdornment>,
                                    endAdornment:
                                        (endAdornment && <InputAdornment
                                            onClick={onClickIconEnd}
                                            position='end'
                                            className={`${error?.message ? 'error-svg' : ''}`}
                                        >
                                            {endAdornment}
                                        </InputAdornment>)
                                        || (type === 'password'
                                            && <InputAdornment
                                                onClick={onClickIconEnd}
                                                position='end'
                                                className={`${error?.message ? 'error-svg-password' : ''}`}
                                            >
                                                <EndIcon/>
                                            </InputAdornment>),
                                }}
                            />
                            {showError && <p className='error-message'>{error?.message}</p>}
                        </div>
                    );
                }
                }
            />
        );
    });

InputMain.displayName = 'InputMain';


